import React from 'react';
import PopUpDialogTemplate from './PopUpDialogTemplate';
import { formatCurrency } from '../../../../helpers/format';

const BTN_NAMES = { confirm: 'Lobby' };
const scoresClassName = 'tournaments__dialog-completed__scores';
const scoresWinnerClassName = scoresClassName + '--winner';
const scoresLoserClassName = scoresClassName + '--loser';

const TournamentCompletedDialog = ({ onClose, onConfirm, score, won }) => {
  return (
    <div className="tournaments__popup tournaments__dialog-completed">
      <div className="tournaments__popup__overlay tournaments__dialog-completed__overlay" onClick={onClose} />
      <PopUpDialogTemplate
        title="Congratulations!"
        iconName="congrats"
        onClose={onClose}
        onConfirm={onConfirm}
        btnNames={BTN_NAMES}
      >
        <div className="tournaments__dialog-completed__text">You have successfully completed this Tournament.</div>
        <div className={`${scoresClassName} ${won ? scoresWinnerClassName : scoresLoserClassName}`}>
          <div className="tournaments__dialog-completed__score">
            <div className="tournaments__dialog-completed__score-label">Your Score:</div>
            <div className="tournaments__dialog-completed__score-value">{score}</div>
          </div>
          {won && <div className="tournaments__dialog-completed__score tournaments__dialog-completed__score--win">
            <div className="tournaments__dialog-completed__score-label">You won:</div>
            <div className="tournaments__dialog-completed__score-value">
              {formatCurrency(won.value, 'eng', won.currency)}
            </div>
          </div>}
        </div>
      </PopUpDialogTemplate>
    </div>
  );
}

export default TournamentCompletedDialog;